import React from 'react';
import { TConnector, TField, TFieldDataConfiguration, TIndexState, TProductCategory, TSubmodel, TUpsertISRProjectDataModelsInput } from '../model';
import FieldComponent from 'Pages/GMS/ISR/Components/FieldComponent';
import FractionConfiguration from 'Pages/GMS/ISR/Components/FractionConfiguration';
import useFieldDataConfigurationUpdater from '../Hooks/useFieldDataConfigurationUpdater';
import RulesComponent from 'Pages/GMS/ISR/Components/Rules/RulesComponent';
import AdditionalData from 'Pages/GMS/ISR/Components/AdditionalData';

type FractionalFieldProps = {
    id: string;
    selectedItem: TField | TSubmodel | TProductCategory | TConnector | null;
    userProjectDataModels: TUpsertISRProjectDataModelsInput;
    setUserProjectDataModels: React.Dispatch<React.SetStateAction<TUpsertISRProjectDataModelsInput>>;
    indexInfo: TIndexState;
    createISRProject:()=>void

}

const FractionalField = ({id, selectedItem, userProjectDataModels, setUserProjectDataModels, indexInfo, createISRProject}: FractionalFieldProps) => {

    const { updateFieldConfiguration } = useFieldDataConfigurationUpdater({ setUserProjectDataModels });

    const updateFieldDataConfiguration = (updatedConfig: TFieldDataConfiguration) => {
        updateFieldConfiguration(indexInfo, updatedConfig, (selectedItem && 'belongsToDataModel' in selectedItem && selectedItem?.belongsToDataModel) ?? false);
    };

    return (
        <div id={id}>
            <FieldComponent 
                id={`${id}-field`}
                selectedItem={selectedItem} 
                userProjectDataModels={userProjectDataModels} 
                setUserProjectDataModels={setUserProjectDataModels} 
                indexInfo={indexInfo}
            />
            <br />
            <FractionConfiguration 
                id={`${id}-fraction-config`}
                selectedItem={selectedItem} 
                updateFieldDataConfiguration={updateFieldDataConfiguration} 
                userProjectDataModels={userProjectDataModels} 
                indexInfo={indexInfo} 
                projectId={userProjectDataModels?.project?.id ?? ''}
            />
            <br />
            <AdditionalData 
                id={`${id}-additional-data`}
                selectedItem={selectedItem} 
                userProjectDataModels={userProjectDataModels} 
                setUserProjectDataModels={setUserProjectDataModels} 
                indexInfo={indexInfo}
            />
            <br/>
            <RulesComponent 
                id={`${id}-rules`}
                selectedItem={selectedItem} 
                userProjectDataModels={userProjectDataModels} 
                setUserProjectDataModels={setUserProjectDataModels} 
                indexInfo={indexInfo} 
                createISRProject={createISRProject} 
                featureType="Field"
            />
        </div>
    );
}

export default FractionalField;